import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { CreateTicketInput, FaqEntry, PolicyView, TicketReplyInput, TicketSummary, TicketView, } from '../../help.js';
export const helpRoutes = {
    ticketCreate: {
        method: 'POST',
        path: '/support/tickets',
        body: CreateTicketInput,
        response: TicketView,
    },
    ticketList: {
        method: 'GET',
        path: '/support/tickets',
        query: CursorQuery,
        response: Paginated(TicketSummary),
    },
    ticketGet: { method: 'GET', path: '/support/tickets/:ticketId', response: TicketView },
    ticketReply: {
        method: 'POST',
        path: '/support/tickets/:ticketId/replies',
        body: TicketReplyInput,
        response: TicketView,
    },
    policy: { method: 'GET', path: '/policies/:kind', response: PolicyView },
    faq: { method: 'GET', path: '/faq', response: z.array(FaqEntry) },
};
//# sourceMappingURL=routes.js.map